import { Typography, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto', padding: '40px 24px' }}>
      <div style={{ marginBottom: 24 }}>
        <a onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
          <ArrowLeftOutlined /> 返回
        </a>
      </div>
      
      <Card>
        <Typography>
          <Title level={1}>服务条款</Title>
          <Paragraph>
            <Text type="secondary">最后更新日期: {new Date().toLocaleDateString('zh-CN')}</Text>
          </Paragraph>

          <Title level={2}>1. 服务说明</Title>
          <Paragraph>
            欢迎使用TraderMind（以下简称"本服务"）。本服务是一款专为交易者设计的心理管理和交易记录工具。
            通过使用本服务，您同意遵守本服务条款的所有规定。
          </Paragraph>

          <Title level={2}>2. 账户注册</Title>
          <Paragraph>
            2.1 您需要注册一个账户才能使用本服务的完整功能。
          </Paragraph>
          <Paragraph>
            2.2 您必须提供真实、准确、完整的注册信息。
          </Paragraph>
          <Paragraph>
            2.3 您有责任维护账户密码的安全性和保密性。
          </Paragraph>
          <Paragraph>
            2.4 您对在您账户下发生的所有活动负责。
          </Paragraph>

          <Title level={2}>3. 用户行为规范</Title>
          <Paragraph>
            在使用本服务时，您同意：
          </Paragraph>
          <Paragraph>
            3.1 不得使用本服务进行任何非法活动。
          </Paragraph>
          <Paragraph>
            3.2 不得上传、发布或传输任何违法、有害、威胁、辱骂、骚扰、侵权、诽谤或其他令人反感的内容。
          </Paragraph>
          <Paragraph>
            3.3 不得干扰或破坏本服务的正常运行。
          </Paragraph>
          <Paragraph>
            3.4 不得试图未经授权访问本服务的任何部分。
          </Paragraph>

          <Title level={2}>4. 知识产权</Title>
          <Paragraph>
            4.1 本服务及其所有内容、功能和特性（包括但不限于所有信息、软件、文本、显示、图像、视频和音频）
            均为TraderMind及其许可方所有。
          </Paragraph>
          <Paragraph>
            4.2 您保留对您上传到本服务的内容的所有权利。
          </Paragraph>

          <Title level={2}>5. 数据使用</Title>
          <Paragraph>
            5.1 您的交易记录、情绪日志等个人数据仅用于为您提供服务。
          </Paragraph>
          <Paragraph>
            5.2 我们可能会使用匿名化的统计数据来改进服务质量。
          </Paragraph>
          <Paragraph>
            5.3 详细的数据处理方式请参阅我们的隐私政策。
          </Paragraph>

          <Title level={2}>6. 免责声明</Title>
          <Paragraph>
            6.1 本服务按"现状"提供，不提供任何明示或暗示的保证。
          </Paragraph>
          <Paragraph>
            6.2 本服务提供的所有信息和工具仅供参考，不构成投资建议。
          </Paragraph>
          <Paragraph>
            6.3 您应自行承担使用本服务进行交易决策的所有风险。
          </Paragraph>
          <Paragraph>
            6.4 我们不对因使用或无法使用本服务而导致的任何损失负责。
          </Paragraph>

          <Title level={2}>7. 服务变更和终止</Title>
          <Paragraph>
            7.1 我们保留随时修改或终止本服务（或其任何部分）的权利，无需事先通知。
          </Paragraph>
          <Paragraph>
            7.2 我们可能因任何原因暂停或终止您的账户，包括但不限于违反本服务条款。
          </Paragraph>

          <Title level={2}>8. 条款修改</Title>
          <Paragraph>
            我们保留随时修改本服务条款的权利。修改后的条款将在发布后立即生效。
            继续使用本服务即表示您接受修改后的条款。
          </Paragraph>

          <Title level={2}>9. 适用法律</Title>
          <Paragraph>
            本服务条款受中华人民共和国法律管辖。
          </Paragraph>

          <Title level={2}>10. 联系我们</Title>
          <Paragraph>
            如果您对本服务条款有任何疑问，请通过以下方式联系我们：
          </Paragraph>
          <Paragraph>
            邮箱: support@tradermind.com
          </Paragraph>
        </Typography>
      </Card>
    </div>
  );
}
